$().ready(function () {
  
$('.sizebox').on('input',function(){
  var lgt = $("#lgt").val(),wdt = $("#wdt").val(),grt = $('#graveltype').val(), hdn = $('#showhide').val();
  console.log(lgt,wdt,grt,hdn);
  var dty;
  if(grt == 10){dty = 1478;}
  if(grt == 20){dty = 1560;}
  if(grt == 30 || grt == 40){dty = 1700;}
  var dpt = hdn/1000;
  var lbl = hdn+'mm';
  if(hdn == '40'){
    lbl = lbl+' (flush)';
  }
  if(hdn == '50'){
    lbl = lbl+' (hide grids)';
  }
  
  var total = lgt*wdt*dty*dpt
  $('#flush').html(total.toFixed(2));
  $('#filltype').html(lbl);
  $('#stonetype').html(grt+'mm');
  console.log(total);
})
});
